var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankingFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 669,
    height: 482.672,
    viewBox: "0 0 669 482.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2.456,
    y1: 0.5,
    x2: -1.456,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 0.975,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e00016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e00016",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 30.697,
    y1: 0.004,
    x2: 29.473,
    y2: 0.994,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 26.358,
    y1: -0.007,
    x2: 25.658,
    y2: 1.009,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -10.156,
    y1: 5.823,
    x2: -8.699,
    y2: 4.808,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -12.072,
    y1: 7.853,
    x2: -11.871,
    y2: 7.247,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -15.959,
    y1: 9.86,
    x2: -14.41,
    y2: 8.73,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -79.909,
    y1: -36.233,
    x2: -80.911,
    y2: -35.732,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.411,
    y1: 0.932,
    x2: 0.634,
    y2: -0.163,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.477,
    y1: 1.26,
    x2: 0.521,
    y2: -0.718,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3174ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.502,
    y1: -8.542,
    x2: 0.499,
    y2: 4.069,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.167,
    y1: 0.124,
    x2: 0.76,
    y2: 1.05,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -85.827,
    y1: -96.875,
    x2: -86.017,
    y2: -93.155,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -0.869,
    y1: -1.709,
    x2: 0.56,
    y2: 0.739,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -75.176,
    y1: -111.004,
    x2: -75.397,
    y2: -107.895,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 25.904,
    y1: -0.845,
    x2: 25.275,
    y2: 0.879,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 3.837,
    y1: -0.208,
    x2: 3.147,
    y2: 0.57,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 101.394,
    y1: 0.088,
    x2: 98.857,
    y2: 2.712,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.903,
    y1: -0.677,
    x2: 0.377,
    y2: 1.163,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.323,
    y1: -0.088,
    x2: 0.922,
    y2: 2.272,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0,
    y1: 0.507,
    x2: 0.948,
    y2: 0.493,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -35.234,
    y1: -207.514,
    x2: -38.014,
    y2: -203.94,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -2.841,
    y1: 0.542,
    x2: 1.033,
    y2: 0.496,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -65.476,
    y1: -25.987,
    x2: -66.215,
    y2: -23.55,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 46.863,
    y1: 0.565,
    x2: 51.938,
    y2: -0.107,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 749.898,
    y1: 0.954,
    x2: 752.06,
    y2: -0.303,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 86.157,
    y1: 0.058,
    x2: 86.412,
    y2: -21.503,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 64.439,
    y1: 4.039,
    x2: 64.635,
    y2: -0.315,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 0.499,
    y1: 0.585,
    x2: 0.451,
    y2: 3.763,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -101.824,
    y1: -5.347,
    x2: -100.696,
    y2: -5.347,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -14.77,
    y1: -0.378,
    x2: -14.078,
    y2: -1.289,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1.021,
    y1: -3.279,
    x2: 0.514,
    y2: 0.398,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -30.834,
    y1: -7.503,
    x2: -29.901,
    y2: -7.503,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -87.849,
    y1: -5.746,
    x2: -86.947,
    y2: -5.746,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -12.319,
    y1: 0.095,
    x2: -12.288,
    y2: -0.883,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -12.365,
    y1: -10.677,
    x2: -9.067,
    y2: -13.63,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -25.653,
    y1: -2.289,
    x2: -24.66,
    y2: -2.289,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 0.219,
    y1: -0.14,
    x2: 1.183,
    y2: 1.276,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -48.593,
    y1: -2.988,
    x2: -47.473,
    y2: -2.988,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -0.327,
    y1: -0.484,
    x2: 1.3,
    y2: 1.465,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 0.934,
    y1: -1.192,
    x2: 0.316,
    y2: 1.531,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -33.049,
    y1: -32.914,
    x2: -34.1,
    y2: -31.63,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -23.732,
    y1: -21.448,
    x2: -22.848,
    y2: -21.448,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -101.243,
    y1: -109.114,
    x2: -98.823,
    y2: -111.791,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 74.576,
    y1: 57.779,
    x2: 73.837,
    y2: 60.216,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 57.258,
    y1: 0.134,
    x2: 56.857,
    y2: 0.8,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -0.184,
    y1: 1.294,
    x2: 0.486,
    y2: 0.516,
    xlinkHref: "#linear-gradient-28"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 0.878,
    y1: -0.071,
    x2: -1.173,
    y2: 3.028,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1.304,
    y1: -0.302,
    x2: -1.589,
    y2: 2.559,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1.304,
    y1: -0.302,
    x2: -1.589,
    y2: 2.559,
    xlinkHref: "#linear-gradient-20"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1973",
    "data-name": "Group 1973",
    transform: "translate(-954.5 -302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3845",
    "data-name": "Path 3845",
    d: "M741.377,139.575c50.054,41.17-16.856,94.016,17.807,117.086s178.224,68.063,33.654,157.322S644.3,562.386,541.091,505.869,445.3,439.2,360.37,477.4s-173.7-21.236-143.517-91.786,49.4-69.67,14.934-114.724,19.432-169.73,138.065-73.379S562.74,221.932,575.766,185.9,662.275,74.512,741.377,139.575Z",
    transform: "translate(767.375 188)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1972",
    "data-name": "Group 1972",
    transform: "translate(-8599 33.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10269",
    "data-name": "Rectangle 10269",
    d: "M31,0H78a28,28,0,0,1,28,28V148a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V31A31,31,0,0,1,31,0Z",
    transform: "translate(9913 277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_Copy_2",
    "data-name": "Rectangle Copy 2",
    d: "M31.93,2.851A29.052,29.052,0,0,0,2.851,31.93V148.815H105.482V31.93A29.052,29.052,0,0,0,76.4,2.851H31.93M31.93,0H76.4a31.93,31.93,0,0,1,31.93,31.93V151.666H0V31.93A31.93,31.93,0,0,1,31.93,0Z",
    transform: "translate(9912.785 275.2)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(9928.76 312.865)",
    fill: "none",
    stroke: "#e00016",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 39,
    rx: 19.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 75,
    height: 37,
    rx: 18.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(9943.76 324.865)",
    fill: "#e00016"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_Copy",
    "data-name": "Oval Copy",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(9973.76 324.865)",
    fill: "#e00016"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M0,0S7.587,9.123,18.9,9.123,37.631,0,37.631,0",
    transform: "translate(9946.996 374.409)",
    fill: "none",
    stroke: "#e00016",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1960",
    "data-name": "Group 1960",
    transform: "translate(984.867 489.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3036",
    "data-name": "Path 3036",
    d: "M350.569,915.223S326.7,812.659,265.806,739.9c-11.186-13.366-32.881-5.577-32.967,11.852C232.591,802.437,248.74,885.338,350.569,915.223Z",
    transform: "translate(-232.837 -733.15)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3037",
    "data-name": "Path 3037",
    d: "M283.431,788.736c1.809,7.707,4.16,15.221,6.688,22.693q3.856,11.179,8.443,22.1a351.529,351.529,0,0,0,21.217,42.321c4.045,6.788,8.255,13.485,12.8,19.955,2.226,3.267,4.63,6.411,6.963,9.6,2.435,3.117,4.828,6.265,7.406,9.267a219.606,219.606,0,0,0,33.8,33.108.852.852,0,0,0,1.112-1.287l-.01-.01A297.765,297.765,0,0,1,350.4,911.9c-2.432-3.041-4.673-6.23-7.023-9.332-2.232-3.192-4.533-6.331-6.659-9.6-1.065-1.63-2.191-3.218-3.234-4.863l-3.161-4.912c-1.042-1.645-2.041-3.318-3.063-4.975s-2.015-3.334-2.99-5.019c-2-3.343-3.907-6.742-5.824-10.135-1.859-3.426-3.718-6.852-5.5-10.321-3.632-6.9-7-13.94-10.3-21.015-3.255-7.095-6.374-14.259-9.3-21.505-2.96-7.229-5.735-14.562-8.271-21.936l-.008-.023a.851.851,0,0,0-1.633.471Z",
    transform: "translate(-268.1 -771.179)",
    fill: "#dce5fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1969",
    "data-name": "Group 1969",
    transform: "translate(954.5 573.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3038",
    "data-name": "Path 3038",
    d: "M258.852,1100.3S208.864,1028.466,153,1010.161c-13.85-4.538-25.751,10.7-18.05,23.073C150.585,1058.361,185.188,1092.967,258.852,1100.3Z",
    transform: "translate(-132.523 -1009.342)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3039",
    "data-name": "Path 3039",
    d: "M157.506,1045.5c4.287,3.9,8.682,7.634,13.13,11.321,2.243,1.818,4.487,3.635,6.75,5.428,2.281,1.77,4.539,3.57,6.839,5.315q13.772,10.509,28.25,20.05c4.789,3.229,9.726,6.231,14.606,9.319l7.445,4.432c1.242.736,2.478,1.483,3.733,2.2l3.788,2.1c10.023,5.749,20.428,10.8,30.891,15.683a.729.729,0,0,0,.632-1.314l-.02-.01-7.737-3.823-3.868-1.911c-1.28-.656-2.54-1.35-3.811-2.023l-7.621-4.043c-2.517-1.392-5.006-2.833-7.511-4.247l-3.751-2.13-3.7-2.215-7.4-4.438c-4.851-3.092-9.757-6.1-14.518-9.33-4.815-3.148-9.538-6.433-14.265-9.714l-7.013-5.03-6.937-5.133c-2.311-1.714-4.58-3.483-6.872-5.222-2.274-1.762-4.529-3.548-6.784-5.335-4.491-3.59-8.96-7.233-13.273-11.01l-.011-.009a.729.729,0,0,0-.971,1.088Z",
    transform: "translate(-149.777 -1033.67)",
    fill: "#dce5fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1966",
    "data-name": "Group 1966",
    transform: "translate(1405.102 328.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3040",
    "data-name": "Path 3040",
    d: "M1662.04,546.693c22.8,4.558,51.912-20.3,61.291-47.451,9.652-27.944-8.045-39.65-7.908-78.426.155-44.048,23.068-50.686,38.224-110.06,3.42-13.4,23.208-90.916-1.318-105.447-22.677-13.435-86.374,25.122-97.538,74.472-7.961,35.189,16.648,49.963,7.25,90.948-8.247,35.961-29.92,36.482-38.224,71.176C1613.706,484.144,1632.106,540.708,1662.04,546.693Z",
    transform: "translate(-1621.024 -202.609)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3041",
    "data-name": "Path 3041",
    d: "M1758.139,732.961c-6.146-47.458,5.844-120.676,16.984-173.74,12.061-57.451,25.75-104.313,25.886-104.781l1.9.557c-.137.466-13.807,47.266-25.852,104.644-11.107,52.911-23.064,125.886-16.954,173.067Z",
    transform: "translate(-1715.468 -378.205)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1967",
    "data-name": "Group 1967",
    transform: "translate(1436.867 451.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3042",
    "data-name": "Path 3042",
    d: "M1757.307,847.353c-29.905-15.582-40.141-69.089-23.142-86.478,11.486-11.75,27.958.609,43.848-11.571,20.289-15.551,5.364-44.839,21.315-82.824,13.575-32.325,46.136-62.914,65.163-56.637,19.918,6.57,30.408,55.315,13.4,84.651-11.062,19.078-27.995,20.015-31.668,37.758-4.263,20.589,16.331,29.978,16.443,49.938C1862.866,818.044,1796.869,867.967,1757.307,847.353Z",
    transform: "translate(-1725.96 -609.017)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3043",
    "data-name": "Path 3043",
    d: "M1880.013,1026.433a1.218,1.218,0,0,1-1.095-1.75c39.646-81.7,51.272-176.469,51.385-177.416a1.218,1.218,0,0,1,2.419.288c-.113.952-11.789,96.132-51.612,178.192A1.218,1.218,0,0,1,1880.013,1026.433Z",
    transform: "translate(-1832.529 -774.395)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3044",
    "data-name": "Path 3044",
    d: "M2150.171,729.275a.582.582,0,0,1-.459-.94c12.514-16.063,26.384-40.2,21.391-63.944-2.973-14.144-11.343-21.52-11.427-21.593a.582.582,0,1,1,.762-.88c.355.308,8.75,7.709,11.8,22.234,2.807,13.349,1.335,35.445-21.612,64.9A.581.581,0,0,1,2150.171,729.275Z",
    transform: "translate(-2021.348 -631.859)",
    fill: "#dce5fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3045",
    "data-name": "Path 3045",
    d: "M1769.262,1187.918a.582.582,0,0,1-.481-.253c-19.231-28.068-25.79-49.755-19.492-64.459,5.6-13.073,19.737-15.506,19.879-15.53a.582.582,0,0,1,.187,1.15c-.136.022-13.663,2.367-19,14.852-6.12,14.314.4,35.621,19.388,63.329a.582.582,0,0,1-.479.911Z",
    transform: "translate(-1740.612 -956.717)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1961",
    "data-name": "Group 1961",
    transform: "translate(1108.129 314.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1723",
    "data-name": "Group 1723",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3046",
    "data-name": "Path 3046",
    d: "M704.652,342.721,663.659,297l-13.153-14.667-1.115-1.244-8.556-9.544a3.053,3.053,0,0,1,.135-4.3l119.879-112.71a3.052,3.052,0,0,1,4.3.131l8.913,9.21,1.155,1.192,13.7,14.158,42,43.4a5.3,5.3,0,0,1-.857,7.237L715.758,343.047a7.672,7.672,0,0,1-11.106-.326Z",
    transform: "translate(-640.014 -153.713)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3047",
    "data-name": "Path 3047",
    d: "M656.528,281.612a2.877,2.877,0,0,1,.169-4.053l114.2-107.368a2.877,2.877,0,0,1,4.055.081l61.395,63.4a5.01,5.01,0,0,1-.874,6.83L726.524,348.26A7.393,7.393,0,0,1,721.2,350.4a7.073,7.073,0,0,1-5.146-2.343Z",
    transform: "translate(-651.003 -164.648)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3048",
    "data-name": "Path 3048",
    d: "M1186.866,341.687a.594.594,0,0,1-.407-1.027l10.386-9.765a4.623,4.623,0,0,0,1.495-3.387,5.144,5.144,0,0,0-1.451-3.514l-21.811-23.2a.594.594,0,1,1,.866-.813l21.81,23.2a6.328,6.328,0,0,1,1.774,4.328,5.8,5.8,0,0,1-1.869,4.252l-10.386,9.764A.592.592,0,0,1,1186.866,341.687Z",
    transform: "translate(-1012.99 -255.573)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3049",
    "data-name": "Path 3049",
    d: "M687.826,323.174l-13.153-14.667L799.391,191.249l13.7,14.154Z",
    transform: "translate(-664.181 -179.886)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3050",
    "data-name": "Path 3050",
    d: "M689.992,543.748a.591.591,0,0,1-.433-.187l-36.645-38.976c-1.91-2.031-1.105-5.455.811-7.257l12.831-12.062a.594.594,0,0,1,.814.865L654.54,498.193c-1.5,1.415-2.148,4.1-.759,5.578l36.645,38.976a.594.594,0,0,1-.433,1Z",
    transform: "translate(-648.249 -384.784)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3051",
    "data-name": "Path 3051",
    d: "M1171.693,378.755a6.914,6.914,0,1,1,.3-9.773A6.914,6.914,0,0,1,1171.693,378.755Z",
    transform: "translate(-1002.619 -302.297)",
    fill: "url(#linear-gradient-10)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3052",
    "data-name": "Path 3052",
    d: "M841.264,827.569a7.635,7.635,0,0,1-7.616,7.609H421.8a7.635,7.635,0,0,1-7.616-7.609L410.76,590.893c0-4.185,4.93-12.355,13.966-11.741l402.5-10.415a19.193,19.193,0,0,1,19.694,19.629Z",
    transform: "translate(627.969 -129.075)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    "data-name": "Path 3053",
    d: "M858.013,841.058a7.227,7.227,0,0,1-7.205,7.205H456a7.227,7.227,0,0,1-7.205-7.205L445.564,626.2c.381-12.93,11.716-17.577,18.588-17.3l385.76-10.349a13.489,13.489,0,0,1,13.839,13.8Z",
    transform: "translate(603.7 -149.863)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1725",
    "data-name": "Group 1725",
    transform: "translate(1054.563 460.291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3054",
    "data-name": "Path 3054",
    d: "M468.383,1018.075a.594.594,0,0,1-.594-.586l-.256-17.424a.6.6,0,0,1,.586-.6h.009a.594.594,0,0,1,.594.585l.256,17.424a.6.6,0,0,1-.585.6Z",
    transform: "translate(-466.182 -889.705)",
    fill: "#fff",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3055",
    "data-name": "Path 3055",
    d: "M464.643,722.565a.594.594,0,0,1-.594-.586l-.98-66.735c.021-4.461,1.395-8.024,4.085-10.6,4.894-4.69,12.551-4.449,12.875-4.441l123.19-3.306a.594.594,0,0,1,.032,1.188L480.027,641.39c-.346-.018-7.517-.234-12.05,4.111-2.449,2.346-3.7,5.622-3.719,9.738l.98,66.724a.594.594,0,0,1-.585.6Z",
    transform: "translate(-463.069 -636.895)",
    fill: "#fff",
    opacity: 0.37
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3056",
    "data-name": "Path 3056",
    d: "M511.873,866.324c.413-17.758.259-175.011-.76-188.592s20.132-16.128,52.607-17.657,306.471-7.579,313.526-8.151c15.858-1.286,19.14,22.417,17.553,73.872-1.192,38.658-3.167,102.341-4.076,131.628A16.162,16.162,0,0,1,874.6,873.087c-65.935.181-318.644.905-335.467,1.406C519.775,875.07,511.71,873.365,511.873,866.324Z",
    transform: "translate(558.019 -187.048)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10268",
    "data-name": "Rectangle 10268",
    width: 485.549,
    height: 20.795,
    rx: 7.505,
    transform: "translate(1017.095 697.388)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1971",
    "data-name": "Group 1971",
    transform: "translate(1083.452 482.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1900",
    "data-name": "Group 1900",
    transform: "translate(263.72 24.697)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10225",
    "data-name": "Rectangle 10225",
    width: 94.565,
    height: 158.883,
    transform: "translate(97.529 158.883) rotate(180)",
    fill: "#aed3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10226",
    "data-name": "Rectangle 10226",
    width: 94.565,
    height: 158.883,
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10227",
    "data-name": "Rectangle 10227",
    width: 81.909,
    height: 55.342,
    transform: "translate(6.44 8.876)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10228",
    "data-name": "Rectangle 10228",
    width: 43.96,
    height: 29.548,
    transform: "translate(42.977 116.151)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3637",
    "data-name": "Path 3637",
    d: "M2713.473,623.279s13.985-1.743,22.531,6.13,24.466.7,30.876,0c11.145-1.213,19.882,2.433,22.473,6.441v12.024h-75.88Z",
    transform: "translate(-2703.655 -586.158)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10229",
    "data-name": "Rectangle 10229",
    width: 0.586,
    height: 18.776,
    transform: "translate(20.657 17.771)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10230",
    "data-name": "Rectangle 10230",
    width: 0.586,
    height: 18.776,
    transform: "translate(43.656 25.828)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10231",
    "data-name": "Rectangle 10231",
    width: 0.586,
    height: 18.776,
    transform: "translate(67.387 21.58)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3638",
    "data-name": "Path 3638",
    d: "M2816.536,493.584h-4.492a.49.49,0,0,1-.488-.488h0a.49.49,0,0,1,.488-.488h4.492a.49.49,0,0,1,.489.488h0A.49.49,0,0,1,2816.536,493.584Z",
    transform: "translate(-2788.75 -472.933)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3639",
    "data-name": "Path 3639",
    d: "M2816.536,506.859h-4.492a.49.49,0,0,1-.488-.488h0a.49.49,0,0,1,.488-.488h4.492a.49.49,0,0,1,.489.488h0A.49.49,0,0,1,2816.536,506.859Z",
    transform: "translate(-2788.75 -484.449)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3640",
    "data-name": "Path 3640",
    d: "M2987.628,565.856h-4.492a.49.49,0,0,1-.488-.488h0a.49.49,0,0,1,.488-.488h4.492a.49.49,0,0,1,.488.488h0A.49.49,0,0,1,2987.628,565.856Z",
    transform: "translate(-2937.186 -535.634)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3641",
    "data-name": "Path 3641",
    d: "M2987.628,578.858h-4.492a.49.49,0,0,1-.488-.488h0a.49.49,0,0,1,.488-.488h4.492a.49.49,0,0,1,.488.488h0A.49.49,0,0,1,2987.628,578.858Z",
    transform: "translate(-2937.186 -546.914)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3642",
    "data-name": "Path 3642",
    d: "M3169.784,512.39h-4.492a.489.489,0,0,1-.488-.488h0a.489.489,0,0,1,.488-.488h4.492a.49.49,0,0,1,.488.488h0A.49.49,0,0,1,3169.784,512.39Z",
    transform: "translate(-3095.22 -489.247)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3643",
    "data-name": "Path 3643",
    d: "M3169.784,525.391h-4.492a.489.489,0,0,1-.488-.488h0a.489.489,0,0,1,.488-.488h4.492a.49.49,0,0,1,.488.488h0A.49.49,0,0,1,3169.784,525.391Z",
    transform: "translate(-3095.22 -500.528)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1894",
    "data-name": "Group 1894",
    transform: "translate(72.174 70.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3644",
    "data-name": "Path 3644",
    d: "M3184.363,882.885a8.088,8.088,0,1,1,8.088,8.087A8.088,8.088,0,0,1,3184.363,882.885Z",
    transform: "translate(-3184.363 -874.797)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3645",
    "data-name": "Path 3645",
    d: "M3220.058,887.376a7.4,7.4,0,0,1-12.405,5.455l5-5.455v-7.4A7.4,7.4,0,0,1,3220.058,887.376Z",
    transform: "translate(-3204.569 -879.288)",
    fill: "#c65447"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3646",
    "data-name": "Path 3646",
    d: "M3205.275,923.105h-2.658a.223.223,0,0,1-.223-.223h0a.223.223,0,0,1,.223-.223h2.658a.223.223,0,0,1,.223.223h0A.223.223,0,0,1,3205.275,923.105Z",
    transform: "translate(-3200.007 -916.322)",
    fill: "#a6c7f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1895",
    "data-name": "Group 1895",
    transform: "translate(52.094 70.286)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 8.088,
    cy: 8.088,
    r: 8.088,
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3647",
    "data-name": "Path 3647",
    d: "M3045.3,887.376l4.548,5.84a7.4,7.4,0,1,1,2.823-6.516Z",
    transform: "translate(-3037.217 -879.288)",
    fill: "#e57970"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3648",
    "data-name": "Path 3648",
    d: "M3123.269,946.773h-1.85a.224.224,0,0,1-.223-.223h0a.223.223,0,0,1,.223-.223h1.85a.223.223,0,0,1,.223.223h0A.223.223,0,0,1,3123.269,946.773Z",
    transform: "translate(-3109.481 -936.856)",
    fill: "#a6c7f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1896",
    "data-name": "Group 1896",
    transform: "translate(72.174 92.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3649",
    "data-name": "Path 3649",
    d: "M3184.363,1051.1a8.088,8.088,0,1,1,8.088,8.088A8.088,8.088,0,0,1,3184.363,1051.1Z",
    transform: "translate(-3184.363 -1043.01)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3650",
    "data-name": "Path 3650",
    d: "M3220.058,1055.588a7.4,7.4,0,0,1-12.405,5.455l5-5.455v-7.4A7.4,7.4,0,0,1,3220.058,1055.588Z",
    transform: "translate(-3204.569 -1047.501)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3651",
    "data-name": "Path 3651",
    d: "M3205.275,1091.317h-2.658a.223.223,0,0,1-.223-.223h0a.223.223,0,0,1,.223-.223h2.658a.223.223,0,0,1,.223.223h0A.223.223,0,0,1,3205.275,1091.317Z",
    transform: "translate(-3200.007 -1084.534)",
    fill: "#a6c7f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1897",
    "data-name": "Group 1897",
    transform: "translate(52.094 92.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3652",
    "data-name": "Path 3652",
    d: "M3032.729,1051.1a8.088,8.088,0,1,1,8.087,8.088A8.088,8.088,0,0,1,3032.729,1051.1Z",
    transform: "translate(-3032.729 -1043.01)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    "data-name": "Path 3653",
    d: "M3052.676,1054.912a7.4,7.4,0,1,0-2.823,6.516l-4.548-5.84Z",
    transform: "translate(-3037.217 -1047.501)",
    fill: "#c65447"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3654",
    "data-name": "Path 3654",
    d: "M3123.269,1114.986h-1.85a.223.223,0,0,1-.223-.222h0a.224.224,0,0,1,.223-.223h1.85a.223.223,0,0,1,.223.223h0A.223.223,0,0,1,3123.269,1114.986Z",
    transform: "translate(-3109.481 -1105.069)",
    fill: "#a6c7f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1898",
    "data-name": "Group 1898",
    transform: "translate(44.692 119.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3655",
    "data-name": "Path 3655",
    d: "M3017.178,1272.489h-40.351v-23.842h.5v23.34h39.849Z",
    transform: "translate(-2976.827 -1248.647)",
    fill: "#a6c7f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1899",
    "data-name": "Group 1899",
    transform: "translate(47.113 120.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3656",
    "data-name": "Path 3656",
    d: "M3005.305,1293.782c-4.939-3.932-10.192,0-10.192,0v6.722h36.927v-17.376C3022,1283.382,3010.245,1297.714,3005.305,1293.782Z",
    transform: "translate(-2995.113 -1279.534)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3657",
    "data-name": "Path 3657",
    d: "M2995.536,1256.836h17.207a.423.423,0,1,0,0-.846h-17.207a.423.423,0,0,0,0,.846Z",
    transform: "translate(-2995.113 -1255.991)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3658",
    "data-name": "Path 3658",
    d: "M2995.536,1272.438h17.207a.423.423,0,1,0,0-.846h-17.207a.423.423,0,0,0,0,.846Z",
    transform: "translate(-2995.113 -1269.526)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10232",
    "data-name": "Rectangle 10232",
    d: "M.423,0h11.24a.423.423,0,0,1,.423.423v0a.423.423,0,0,1-.423.423H.423A.423.423,0,0,1,0,.423v0A.423.423,0,0,1,.423,0Z",
    transform: "translate(0 4.016)",
    fill: "#a6c7f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1905",
    "data-name": "Group 1905",
    transform: "translate(118.685 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10233",
    "data-name": "Rectangle 10233",
    width: 129.389,
    height: 195.133,
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10234",
    "data-name": "Rectangle 10234",
    width: 104.173,
    height: 116.113,
    transform: "translate(12.502 10.915)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 18.735,
    cy: 18.735,
    r: 18.735,
    transform: "translate(6.956 164.125) rotate(-45)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3659",
    "data-name": "Path 3659",
    d: "M1708.784,1293.176a15.837,15.837,0,1,0-6.231,12.592l-9.6-12.592,14.8,5.648A15.814,15.814,0,0,0,1708.784,1293.176Z",
    transform: "translate(-1659.497 -1129.051)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    cx: 18.735,
    cy: 18.735,
    r: 18.735,
    transform: "translate(74.746 178.055) rotate(-76.718)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3660",
    "data-name": "Path 3660",
    d: "M2174.983,1277.339a15.837,15.837,0,0,0-11.287,26.946l11.287-11.109,14.8,5.648a15.847,15.847,0,0,0-14.8-21.486Z",
    transform: "translate(-2077.699 -1129.051)",
    fill: "#ee9849"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1901",
    "data-name": "Group 1901",
    transform: "translate(87.747 156.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3661",
    "data-name": "Path 3661",
    d: "M2213.943,1336.222H2207.2a.483.483,0,0,0-.482.481h0a.483.483,0,0,0,.482.481h6.741a.483.483,0,0,0,.481-.481h0A.483.483,0,0,0,2213.943,1336.222Z",
    transform: "translate(-2206.72 -1336.222)",
    fill: "#dd7c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3662",
    "data-name": "Path 3662",
    d: "M2213.943,1347.736H2207.2a.482.482,0,1,0,0,.963h6.741a.482.482,0,0,0,0-.963Z",
    transform: "translate(-2206.72 -1346.211)",
    fill: "#dd7c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3663",
    "data-name": "Path 3663",
    d: "M2209.985,1359.252H2207.2a.481.481,0,1,0,0,.963h2.783a.481.481,0,0,0,0-.963Z",
    transform: "translate(-2206.72 -1356.202)",
    fill: "#dd7c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1902",
    "data-name": "Group 1902",
    transform: "translate(23.784 156.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3664",
    "data-name": "Path 3664",
    d: "M1730.926,1336.222h-6.741a.483.483,0,0,0-.481.481h0a.483.483,0,0,0,.481.481h6.741a.483.483,0,0,0,.482-.481h0A.483.483,0,0,0,1730.926,1336.222Z",
    transform: "translate(-1723.703 -1336.222)",
    fill: "#dd7c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3665",
    "data-name": "Path 3665",
    d: "M1730.926,1347.736h-6.741a.482.482,0,0,0,0,.963h6.741a.482.482,0,0,0,0-.963Z",
    transform: "translate(-1723.703 -1346.211)",
    fill: "#dd7c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3666",
    "data-name": "Path 3666",
    d: "M1726.968,1359.252h-2.784a.481.481,0,0,0,0,.963h2.784a.481.481,0,0,0,0-.963Z",
    transform: "translate(-1723.703 -1356.202)",
    fill: "#dd7c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1903",
    "data-name": "Group 1903",
    transform: "translate(21.778 33.324)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10235",
    "data-name": "Rectangle 10235",
    width: 10.993,
    height: 68.478,
    transform: "translate(0 19.088)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10236",
    "data-name": "Rectangle 10236",
    width: 10.993,
    height: 87.566,
    transform: "translate(18.009)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10237",
    "data-name": "Rectangle 10237",
    width: 10.993,
    height: 51.918,
    transform: "translate(37.66 35.648)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10238",
    "data-name": "Rectangle 10238",
    width: 10.993,
    height: 75.875,
    transform: "translate(56.782 11.691)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10239",
    "data-name": "Rectangle 10239",
    width: 10.993,
    height: 41.756,
    transform: "translate(76.002 45.809)",
    fill: "#a6c7f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1904",
    "data-name": "Group 1904",
    transform: "translate(40.397 20.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    "data-name": "Path 3667",
    d: "M2149.115,422.915h-9.31a.963.963,0,0,0,0,1.926h9.31a.963.963,0,1,0,0-1.926Z",
    transform: "translate(-2100.482 -408.001)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3668",
    "data-name": "Path 3668",
    d: "M2141.926,449.378h-2.12a.963.963,0,0,0,0,1.926h2.12a.963.963,0,0,0,0-1.926Z",
    transform: "translate(-2100.482 -430.96)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3669",
    "data-name": "Path 3669",
    d: "M1859.427,310.292h-9.31a.963.963,0,1,0,0,1.926h9.31a.963.963,0,0,0,0-1.926Z",
    transform: "translate(-1849.154 -310.292)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3670",
    "data-name": "Path 3670",
    d: "M1852.237,336.755h-2.12a.966.966,0,0,0-.963.963h0a.966.966,0,0,0,.963.963h2.12a.966.966,0,0,0,.963-.963h0A.966.966,0,0,0,1852.237,336.755Z",
    transform: "translate(-1849.154 -333.251)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3671",
    "data-name": "Path 3671",
    d: "M2002.3,601.192h-9.309a.963.963,0,1,0,0,1.926h9.309a.963.963,0,1,0,0-1.926Z",
    transform: "translate(-1973.107 -562.67)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3672",
    "data-name": "Path 3672",
    d: "M1995.11,627.656h-2.12a.966.966,0,0,0-.963.963h0a.966.966,0,0,0,.963.963h2.12a.966.966,0,0,0,.963-.963h0A.966.966,0,0,0,1995.11,627.656Z",
    transform: "translate(-1973.107 -585.63)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3673",
    "data-name": "Path 3673",
    d: "M2291.845,678.373h-9.309a.963.963,0,1,0,0,1.926h9.309a.963.963,0,1,0,0-1.926Z",
    transform: "translate(-2224.311 -629.631)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3674",
    "data-name": "Path 3674",
    d: "M2284.656,704.837h-2.12a.963.963,0,1,0,0,1.926h2.12a.963.963,0,0,0,0-1.926Z",
    transform: "translate(-2224.311 -652.59)",
    fill: "#a6c7f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1909",
    "data-name": "Group 1909",
    transform: "translate(6.66 73.966)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10240",
    "data-name": "Rectangle 10240",
    width: 94.565,
    height: 53.237,
    fill: "#aed3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10241",
    "data-name": "Rectangle 10241",
    width: 94.565,
    height: 53.237,
    transform: "translate(3.075)",
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 17.098,
    cy: 17.098,
    r: 17.098,
    transform: "translate(4.757 25.416) rotate(-45)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1906",
    "data-name": "Group 1906",
    transform: "translate(56.818 15.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3675",
    "data-name": "Path 3675",
    d: "M1157.383,835.892h-28.325a1.872,1.872,0,0,0-1.866,1.866h0a1.872,1.872,0,0,0,1.866,1.867h28.325a1.872,1.872,0,0,0,1.867-1.867h0A1.872,1.872,0,0,0,1157.383,835.892Z",
    transform: "translate(-1127.191 -835.892)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3676",
    "data-name": "Path 3676",
    d: "M1157.383,893.927h-28.325a1.872,1.872,0,0,0-1.866,1.866h0a1.872,1.872,0,0,0,1.866,1.866h28.325a1.872,1.872,0,0,0,1.867-1.866h0A1.872,1.872,0,0,0,1157.383,893.927Z",
    transform: "translate(-1127.191 -886.242)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3677",
    "data-name": "Path 3677",
    d: "M1157.383,951.962h-28.325a1.866,1.866,0,0,0,0,3.733h28.325a1.866,1.866,0,1,0,0-3.733Z",
    transform: "translate(-1127.191 -936.592)",
    fill: "#f3f9ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3678",
    "data-name": "Path 3678",
    d: "M798.435,803.581H814.09V787.926A15.655,15.655,0,0,0,798.435,803.581Z",
    transform: "translate(-785.152 -778.414)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3679",
    "data-name": "Path 3679",
    d: "M829.745,909.951h-31.31a15.656,15.656,0,0,0,15.655,15.655h0A15.656,15.656,0,0,0,829.745,909.951Z",
    transform: "translate(-785.152 -884.28)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1907",
    "data-name": "Group 1907",
    transform: "translate(16.859 17.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3680",
    "data-name": "Path 3680",
    d: "M834.813,845.367h-8.5a.879.879,0,0,0,0,1.758h8.5a.879.879,0,0,0,0-1.758Z",
    transform: "translate(-825.438 -845.367)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3681",
    "data-name": "Path 3681",
    d: "M828.252,869.52h-1.935a.879.879,0,0,0,0,1.758h1.935a.879.879,0,0,0,0-1.758Z",
    transform: "translate(-825.438 -866.322)",
    fill: "#82b378"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1908",
    "data-name": "Group 1908",
    transform: "translate(29.472 29.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3682",
    "data-name": "Path 3682",
    d: "M930.067,938.852h-8.5a.879.879,0,1,0,0,1.758h8.5a.879.879,0,1,0,0-1.758Z",
    transform: "translate(-920.692 -938.852)",
    fill: "#dd8936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3683",
    "data-name": "Path 3683",
    d: "M923.506,963h-1.935a.882.882,0,0,0-.879.879h0a.882.882,0,0,0,.879.879h1.935a.882.882,0,0,0,.879-.879h0A.882.882,0,0,0,923.506,963Z",
    transform: "translate(-920.692 -959.805)",
    fill: "#dd8936"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1912",
    "data-name": "Group 1912",
    transform: "translate(0 136.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3684",
    "data-name": "Path 3684",
    d: "M647.833,1190.109v54.446H742.4v-54.446Z",
    transform: "translate(-647.833 -1190.109)",
    fill: "#aed3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3685",
    "data-name": "Path 3685",
    d: "M671.054,1190.109v54.446h94.565v-54.446Z",
    transform: "translate(-667.979 -1190.109)",
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_215",
    "data-name": "Ellipse 215",
    cx: 17.098,
    cy: 17.098,
    r: 17.098,
    transform: "translate(11.838 8.443)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1910",
    "data-name": "Group 1910",
    transform: "translate(56.817 15.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3686",
    "data-name": "Path 3686",
    d: "M1078.753,1314.59h28.325a1.867,1.867,0,0,0,0-3.733h-28.325a1.867,1.867,0,0,0,0,3.733Z",
    transform: "translate(-1076.887 -1310.857)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3687",
    "data-name": "Path 3687",
    d: "M1107.078,1368.893h-28.325a1.866,1.866,0,1,0,0,3.733h28.325a1.866,1.866,0,1,0,0-3.733Z",
    transform: "translate(-1076.887 -1361.208)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3688",
    "data-name": "Path 3688",
    d: "M1107.078,1426.928h-28.325a1.872,1.872,0,0,0-1.866,1.866h0a1.872,1.872,0,0,0,1.866,1.866h28.325a1.872,1.872,0,0,0,1.866-1.866h0A1.872,1.872,0,0,0,1107.078,1426.928Z",
    transform: "translate(-1076.887 -1411.557)",
    fill: "#f3f9ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3689",
    "data-name": "Path 3689",
    d: "M763.786,1383.779l-15.654-.2c0,.066,0,.133,0,.2a15.656,15.656,0,0,0,24.054,13.212Z",
    transform: "translate(-734.849 -1357.96)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1911",
    "data-name": "Group 1911",
    transform: "translate(20.138 30.749)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10242",
    "data-name": "Rectangle 10242",
    width: 10.254,
    height: 1.758,
    rx: 0.879,
    transform: "translate(0)",
    fill: "#dd8936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3690",
    "data-name": "Path 3690",
    d: "M802.721,1446.461h-1.935a.879.879,0,0,0,0,1.758h1.935a.879.879,0,0,0,0-1.758Z",
    transform: "translate(-799.907 -1443.263)",
    fill: "#dd8936"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1915",
    "data-name": "Group 1915",
    transform: "translate(0 15.905)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10243",
    "data-name": "Rectangle 10243",
    width: 94.566,
    height: 49.337,
    fill: "#aed3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10244",
    "data-name": "Rectangle 10244",
    width: 94.565,
    height: 49.337,
    transform: "translate(3.075)",
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_216",
    "data-name": "Ellipse 216",
    cx: 17.098,
    cy: 17.098,
    r: 17.098,
    transform: "translate(4.756 25.393) rotate(-45)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3691",
    "data-name": "Path 3691",
    d: "M763.788,351.191a15.655,15.655,0,0,0-7.513,29.39c2.508-4.645,7.513-13.736,7.513-13.736l7.412,13.79a15.655,15.655,0,0,0-7.412-29.444Z",
    transform: "translate(-734.851 -341.451)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1913",
    "data-name": "Group 1913",
    transform: "translate(56.817 15.842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10245",
    "data-name": "Rectangle 10245",
    width: 32.058,
    height: 3.733,
    rx: 1.866,
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692",
    "data-name": "Path 3692",
    d: "M1107.081,455.3h-28.325a1.866,1.866,0,0,0,0,3.733h28.325a1.866,1.866,0,0,0,0-3.733Z",
    transform: "translate(-1076.889 -447.62)",
    fill: "#f3f9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693",
    "data-name": "Path 3693",
    d: "M1107.081,513.34h-28.325a1.866,1.866,0,0,0,0,3.733h28.325a1.866,1.866,0,0,0,0-3.733Z",
    transform: "translate(-1076.889 -497.97)",
    fill: "#f3f9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1914",
    "data-name": "Group 1914",
    transform: "translate(20.138 17.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3694",
    "data-name": "Path 3694",
    d: "M809.284,412.94h-8.5a.879.879,0,0,0,0,1.758h8.5a.879.879,0,0,0,0-1.758Z",
    transform: "translate(-799.909 -412.94)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695",
    "data-name": "Path 3695",
    d: "M802.723,437.092h-1.935a.882.882,0,0,0-.879.879h0a.881.881,0,0,0,.879.879h1.935a.881.881,0,0,0,.879-.879h0A.881.881,0,0,0,802.723,437.092Z",
    transform: "translate(-799.909 -433.894)",
    fill: "#82b378"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1963",
    "data-name": "Group 1963",
    transform: "translate(1031.904 361.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3072",
    "data-name": "Path 3072",
    d: "M394.493,576.794c.046-.018,24.71-43.21,28.043-47.275a2.584,2.584,0,0,1,2.307-.927l6.884.82,8.087,17.5-13.473-7.847c1.333,9.221-15.975,22.923-21.911,27.923a1.364,1.364,0,0,0-.108,1.986l2.37,2.48a27.217,27.217,0,0,1-13.447,7.647Z",
    transform: "translate(-391.722 -462.727)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3073",
    "data-name": "Path 3073",
    d: "M401.815,665.792a3.49,3.49,0,0,1,2.025,1.835,1.541,1.541,0,0,1-.58,1.776c-2.49,1.785-10.705,7.545-14.5,8.673a.429.429,0,0,1-.536-.505,13.653,13.653,0,0,1,2.851-5.214l-.182.368a.527.527,0,0,0,.729.7C394.161,671.989,399.326,668.856,401.815,665.792Z",
    transform: "translate(-388.217 -558.406)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    "data-name": "Path 3074",
    d: "M427.362,598.646c.041-.027,3.742-8.942,3.783-8.968a156.991,156.991,0,0,1,14.112-43,2.584,2.584,0,0,1,2.071-1.375l6.908-.59,11.461,15.5-14.783-4.958c3.172,8.76-11.005,25.682-15.807,31.78a1.363,1.363,0,0,0,.3,1.966l2.823,1.95a27.22,27.22,0,0,1-11.621,10.21Z",
    transform: "translate(-414.984 -473.978)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M434.505,694.029a3.489,3.489,0,0,1,2.354,1.388,1.54,1.54,0,0,1-.208,1.857c-2.078,2.251-8.957,9.555-12.441,11.427a.429.429,0,0,1-.628-.386,13.662,13.662,0,0,1,1.737-5.683l-.1.4a.527.527,0,0,0,.855.533C428.264,701.647,432.687,697.534,434.505,694.029Z",
    transform: "translate(-412.876 -578.095)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1743",
    "data-name": "Group 1743",
    transform: "translate(27.622 67.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    "data-name": "Path 3076",
    d: "M523.426,533.3s6.249,9.294,6.762,13.534-1.728,5.706-8.268,6.246c-19.463,1.609-29.058-4.224-29.058-4.224-1.332-8.489-2.279-10.649-13.4-15.265,0,0,14.064,1.117,16.9.018S523.426,533.3,523.426,533.3Z",
    transform: "translate(-479.463 -533.024)",
    fill: "url(#linear-gradient-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1745",
    "data-name": "Group 1745",
    transform: "translate(35.061 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3077",
    "data-name": "Path 3077",
    d: "M513.472,337.417c-3.546-.029-7.236.9-8.747-1.214-2.223-3.11,1.16-11.555,6.83-13.754,5.919-2.3,10.036,3.882,16.362,1.617,4.942-1.769,4.561-6.3,9.167-9.723,7.642-5.675,22.89-3.743,28.592,3.818,9.321,12.359-6.678,40.013-18.8,40.346C536.118,358.8,530.126,337.554,513.472,337.417Z",
    transform: "translate(-504.035 -311.057)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3078",
    "data-name": "Path 3078",
    d: "M539.123,452.26a142.657,142.657,0,0,1-10.859-11.519,9.738,9.738,0,0,1-1.649-8.763c1.635-5.51,4.542-11.216,4.807-12.1.406-1.361,8.565-1.3,8.565-1.3s16.056,10.42,22.364,28.072l-7.085,2.205a82.811,82.811,0,0,0-8.334-11.5s7.167,9.469,7.419,13.345Z",
    transform: "translate(-519.497 -386.023)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3079",
    "data-name": "Path 3079",
    d: "M523.065,519.655l5.468-5.949,6.315,1.7s7.362,1.141,11.575,0l4.214-1.141,9.522-2.964,1.5,4.226a2.546,2.546,0,0,1-.93,2.924,16.855,16.855,0,0,1-2.4,1.5c-1.254.549-28.886.173-28.886.173Z",
    transform: "translate(-517.304 -450.684)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3080",
    "data-name": "Path 3080",
    d: "M542.115,384.344l5.484,10.2c-.362,2.226-5.969,2.289-6.835.96a1.315,1.315,0,0,1-.172-.45l-3.28-6.814c-.141-.664,1.681-2.9,2.28-3.222l2.18-1.16C542.611,383.408,539.109,383.373,542.115,384.344Z",
    transform: "translate(-527.233 -361.607)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1744",
    "data-name": "Group 1744",
    transform: "translate(1.838 13.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3081",
    "data-name": "Path 3081",
    d: "M516.395,372.538s-.619,3.445,2.089,7.826,5.4,4.183,6.774,2.62a9.626,9.626,0,0,0,2.264-8.533C526.776,370.082,517.33,368.144,516.395,372.538Z",
    transform: "translate(-514.449 -366.008)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    "data-name": "Path 3082",
    d: "M519.9,365.606s-4.385-5.759-7.751-.739l.057,1.734s-2.516,1.386-2.041-2.649,2.186-8.381,7.141-7,7.85,2.949,8.409,6.389-2.249,2.878-2.249,2.878-1.073-2.373-2.369-2.536-.828,1.716-.828,1.716Z",
    transform: "translate(-510.108 -356.689)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3083",
    "data-name": "Path 3083",
    d: "M543.317,377.276s-2.271-2.947-.2-3.559,1.99,2.888,1.855,4.19Z",
    transform: "translate(-532.516 -368.513)",
    fill: "url(#linear-gradient-25)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1746",
    "data-name": "Group 1746",
    transform: "translate(9.43 48.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3084",
    "data-name": "Path 3084",
    d: "M522.2,541.429l-.058,0-25.15-.028a1.126,1.126,0,1,1,0-2.251l25.149.027a1.126,1.126,0,0,1,.055,2.25Z",
    transform: "translate(-472.711 -518.594)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3085",
    "data-name": "Path 3085",
    d: "M421.043,471.244h20.945a3.992,3.992,0,0,1,3.611,2.289l9.683,20.532H429.252A2.426,2.426,0,0,1,427,492.53l-7.508-19A1.673,1.673,0,0,1,421.043,471.244Z",
    transform: "translate(-419.369 -471.244)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3086",
    "data-name": "Path 3086",
    d: "M465.941,501.188c.454,1.41.119,2.78-.749,3.059s-1.939-.638-2.392-2.048-.119-2.78.749-3.059S465.487,499.778,465.941,501.188Z",
    transform: "translate(-449.511 -490.661)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3087",
    "data-name": "Path 3087",
    d: "M563.131,349.911c-.067,0-.133,0-.2,0-2.615-.078-5.3-1.348-8.206-3.881-4.526-3.946-6.249-4.593-9.825-4.593l-.317,0v-.146h.3c3.578,0,5.406.677,9.939,4.629,2.88,2.51,5.534,3.768,8.115,3.845,2.783.082,5.685-1.627,7.948-4.693a39.642,39.642,0,0,0,2.612-4.249,42.56,42.56,0,0,1,2.43-4,8.957,8.957,0,0,1,3.158-2.945,4.126,4.126,0,0,1,4.189.17l-.086.118a3.982,3.982,0,0,0-4.039-.157,8.827,8.827,0,0,0-3.1,2.9,42.466,42.466,0,0,0-2.421,3.986A39.732,39.732,0,0,1,571,345.155C568.762,348.188,565.905,349.911,563.131,349.911Z",
    transform: "translate(-497.247 -326.63)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3088",
    "data-name": "Path 3088",
    d: "M596.9,366.268a6.979,6.979,0,0,1-.811-.046,5.025,5.025,0,0,1-4.28-3.114l.139-.044a4.879,4.879,0,0,0,4.158,3.013,9.825,9.825,0,0,0,6.8-2.188,32.8,32.8,0,0,0,4.04-3.758c.417-.434.848-.883,1.279-1.316a49.46,49.46,0,0,1,6.15-5.232,8.475,8.475,0,0,1,4.743-1.993c.057,0,.115,0,.173,0a3.779,3.779,0,0,1,2.751,1.438,2.481,2.481,0,0,1,.508,2.084l-.142-.033a2.338,2.338,0,0,0-.482-1.963,3.627,3.627,0,0,0-2.641-1.38,8.107,8.107,0,0,0-4.826,1.963,49.281,49.281,0,0,0-6.132,5.217c-.43.432-.861.88-1.277,1.314a32.92,32.92,0,0,1-4.059,3.774A10.482,10.482,0,0,1,596.9,366.268Z",
    transform: "translate(-530.176 -339.321)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3089",
    "data-name": "Path 3089",
    d: "M609.73,387.335a4.352,4.352,0,0,1-1.985-.457l.065-.13c2.316,1.17,5.091-.328,6.176-1.027a35.5,35.5,0,0,0,3.463-2.661,20.932,20.932,0,0,1,5.977-3.933,6.3,6.3,0,0,1,3.158-.413,3.554,3.554,0,0,1,2.611,1.736l-.128.068a3.409,3.409,0,0,0-2.506-1.661,6.171,6.171,0,0,0-3.084.406,20.822,20.822,0,0,0-5.933,3.908,35.713,35.713,0,0,1-3.478,2.671A8.516,8.516,0,0,1,609.73,387.335Z",
    transform: "translate(-541.289 -358.192)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1970",
    "data-name": "Group 1970",
    transform: "translate(1341.592 623.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1748",
    "data-name": "Group 1748",
    transform: "translate(72.259 95.793)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10045",
    "data-name": "Rectangle 10045",
    width: 4.232,
    height: 45.766,
    transform: "translate(21.87 10.898)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10046",
    "data-name": "Rectangle 10046",
    d: "M2.556,0H34.311a2.755,2.755,0,0,1,2.755,2.755v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v-.2A2.556,2.556,0,0,1,2.556,0Z",
    transform: "translate(5.453 54.792)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10047",
    "data-name": "Rectangle 10047",
    d: "M7.023,0H42.5a7.023,7.023,0,0,1,7.023,7.023v0A7.023,7.023,0,0,1,42.5,14.047H7.023A7.023,7.023,0,0,1,0,7.023v0A7.023,7.023,0,0,1,7.023,0Z",
    fill: "url(#linear-gradient-30)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1750",
    "data-name": "Group 1750",
    transform: "translate(33.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3090",
    "data-name": "Path 3090",
    d: "M1906.042,1441.019s-13.682,5.893-12.9,12.06c0,0,14.143-2.712,16.673-6.754s1.136-6.384,1.136-6.384Z",
    transform: "translate(-1880.85 -1302.461)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3091",
    "data-name": "Path 3091",
    d: "M1933.331,1421.254l.695,6a1.986,1.986,0,0,1-1.257,2.109,5.188,5.188,0,0,1-1.734.265,2.313,2.313,0,0,1-2.247-1.687l-1.346-4.856Z",
    transform: "translate(-1904.788 -1289.431)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3092",
    "data-name": "Path 3092",
    d: "M1946.369,1268.991s-25.164-1.164-37.686,6.138.635,42.349.635,42.349,3.271.7,7.981-1.814c0,0-6.721-25.656,4.954-30.119,13.126-5.018,26.7-3.8,26.7-3.8l-2.515-11.964Z",
    transform: "translate(-1887.939 -1183.214)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3093",
    "data-name": "Path 3093",
    d: "M1890.633,1464.966c2.861-.627,11.346-4.142,12.635-4.1s3.115,1.978,3.115,1.978a3.43,3.43,0,0,1-.607,2.571c-2.186,1.7-6.9,4.835-12.371,5.177a9.184,9.184,0,0,1-7.837-2.9A11.207,11.207,0,0,1,1890.633,1464.966Z",
    transform: "translate(-1875.589 -1317.054)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3094",
    "data-name": "Path 3094",
    d: "M1890.584,1481.076c5.476-.343,10.185-3.473,12.371-5.177a10.681,10.681,0,0,1-4.041,3.518c-5.533,3.126-14.679,2.67-16.491,1.967-1.453-.564-1-1.921.324-3.213A9.183,9.183,0,0,0,1890.584,1481.076Z",
    transform: "translate(-1872.769 -1327.533)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3095",
    "data-name": "Path 3095",
    d: "M1946.412,1449.623c-.187.709-2.192,2.838-3.35,4.024a2.28,2.28,0,0,1-2.12.637,5.853,5.853,0,0,1-1.517-.533,1.48,1.48,0,0,1-.573-2.013l2.931-5.329Z",
    transform: "translate(-1912.614 -1306.971)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3096",
    "data-name": "Path 3096",
    d: "M1998.376,1262.177s2.2,15.583-4.155,18.768-20.281,5.27-25.078,13.352-13.415,23.945-21.257,28.5c0,0-4.479-1.456-5.787-3.659,0,0,9.308-24.469,13.191-30.416,3.363-5.151,8.28-12.571,15.266-15.78,2-.919,2.157-3.04,1.8-5.213l-.641-3.956Z",
    transform: "translate(-1915.008 -1178.51)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3097",
    "data-name": "Path 3097",
    d: "M1929.231,1150.557c8.9,2.542,12.889-22.517,12.854-23.126l13.651,15.962s-8.134,14.313-20.417,15.836a14.5,14.5,0,0,1-7.968-1.168A12.763,12.763,0,0,0,1929.231,1150.557Z",
    transform: "translate(-1904.724 -1084.554)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3098",
    "data-name": "Path 3098",
    d: "M1860.624,1175.7c3.881-1.595,7.172,1.588,7.172,1.588,3.845,3.936,6.9,5.923,9.316,6.614a12.764,12.764,0,0,1-1.88,7.5c-4.8-2.2-7.594-6.641-8.746-8.858a1.666,1.666,0,0,0-2.2-.745c-.823.4-1.671,1-1.724,1.829-.1,1.625-2.039,1.721-2.05,1.121a24.082,24.082,0,0,1,1.5-3.811s-4.459,2.86-6.195,3.954-3.214-.711-3.214-.711S1856.744,1177.3,1860.624,1175.7Z",
    transform: "translate(-1852.606 -1117.9)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3099",
    "data-name": "Path 3099",
    d: "M2018.051,1088.184s-11.965-8.163-40.863,6.6c0,0-2.976,3.772-1.582,8.025s18.552,27.27,19.219,38.075c0,0,11.729,6.9,26.955.06C2021.779,1140.944,2026.885,1112.412,2018.051,1088.184Z",
    transform: "translate(-1938.112 -1055.618)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3100",
    "data-name": "Path 3100",
    d: "M2012.662,1058.894l4.729,9.266a2.634,2.634,0,0,1-.273,2.84c-1.3,1.631-4.02,3.824-8.659,2.411a4.063,4.063,0,0,1-2.769-2.947l-2.451-10.342Z",
    transform: "translate(-1957.639 -1036.765)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3101",
    "data-name": "Path 3101",
    d: "M2113.527,1125.724c.81-5.632-14.073-16.549-14.073-16.549l5.213-15.806s28.4,20.267,22.428,36.819a11.572,11.572,0,0,1-3.69,5.326C2120.4,1129.347,2116.318,1126.783,2113.527,1125.724Z",
    transform: "translate(-2024.728 -1060.803)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3102",
    "data-name": "Path 3102",
    d: "M2048.28,1201.811s16.836,4.7,20.329-.423a2.671,2.671,0,0,0,.435-1.14c2.791,1.059,6.869,3.623,9.877,9.791-7.994,6.288-23.406-.761-27.594-2.874a2.958,2.958,0,0,0-2.218-.186,20.2,20.2,0,0,1-5.508,1.108c-2.1-.116-4.362,7.487-7.942,5.563C2035.658,1213.65,2037.285,1200.66,2048.28,1201.811Z",
    transform: "translate(-1980.244 -1135.328)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1749",
    "data-name": "Group 1749",
    transform: "translate(37.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3103",
    "data-name": "Path 3103",
    d: "M1993.977,1007.629c-.2.174-8.843,15.525-8.843,15.525l8.87,4.748,10.352-13.333S1997.35,1004.71,1993.977,1007.629Z",
    transform: "translate(-1982.375 -1000.642)",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3104",
    "data-name": "Path 3104",
    d: "M1993.874,1001.113l-4.9,7.445a1.236,1.236,0,0,1-.223.255c-.528.459-2.462,1.9-3.819-.165-1.231-1.877-2.383-3.571-3.691-4.151a1.244,1.244,0,0,0-1.589.527,53.786,53.786,0,0,0-3.56,7.557,1.241,1.241,0,0,0,.659,1.542,40.107,40.107,0,0,0,8.854,2.99,1.245,1.245,0,0,0,1.192-.449c1.39-1.747,5.633-7.042,7.044-8.335,1.324-1.213,3.678-.587,4.648-.253a1.223,1.223,0,0,0,.962-.071c1.056-.546,3.188-2.079,1.44-4.978a1.247,1.247,0,0,1,.46-1.735,3.233,3.233,0,0,0,1.557-4.564,4.562,4.562,0,0,0-4.972-2.573,1.246,1.246,0,0,1-1.322-.9.985.985,0,0,0-.872-.705,1.227,1.227,0,0,1-.968-1.535,3.718,3.718,0,0,0-1.855-4.455c-3.816-2.311-7.384,1.046-8.377,3.963s3.287,5.187,6.019,5.651c2.078.352,3.091,2.749,3.458,3.877A1.235,1.235,0,0,1,1993.874,1001.113Z",
    transform: "translate(-1976.02 -985.792)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3105",
    "data-name": "Path 3105",
    d: "M2028.9,1058.217s1.949-5.009,4.164-4.73,3.872,2.567,1.013,4.942C2030.525,1061.383,2028.9,1058.217,2028.9,1058.217Z",
    transform: "translate(-2012.895 -1032.987)",
    fill: "url(#linear-gradient-46)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1751",
    "data-name": "Group 1751",
    transform: "translate(2.677 41.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3106",
    "data-name": "Path 3106",
    d: "M1911.482,1232.617c-.03,0-.06,0-.091,0l-39.332-.043a1.76,1.76,0,1,1,0-3.521l39.332.043a1.761,1.761,0,0,1,.087,3.519Z",
    transform: "translate(-1834.083 -1196.906)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3107",
    "data-name": "Path 3107",
    d: "M1753.278,1122.854h32.756a6.242,6.242,0,0,1,5.647,3.58l15.143,32.11h-40.707a3.794,3.794,0,0,1-3.529-2.4l-11.743-29.713A2.616,2.616,0,0,1,1753.278,1122.854Z",
    transform: "translate(-1750.66 -1122.854)",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3108",
    "data-name": "Path 3108",
    d: "M1823.5,1169.683c.71,2.205.185,4.347-1.171,4.784s-3.032-1-3.742-3.2-.185-4.347,1.171-4.784S1822.786,1167.478,1823.5,1169.683Z",
    transform: "translate(-1797.8 -1153.219)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1753",
    "data-name": "Group 1753",
    transform: "translate(0 76.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1752",
    "data-name": "Group 1752",
    transform: "translate(8.954 3.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3109",
    "data-name": "Path 3109",
    d: "M1773.046,1332.424a1.7,1.7,0,0,1-.652-.131,1.582,1.582,0,0,1-.865-2.1l34.664-78.015a1.674,1.674,0,0,1,2.171-.838,1.581,1.581,0,0,1,.865,2.1l-34.664,78.015A1.656,1.656,0,0,1,1773.046,1332.424Z",
    transform: "translate(-1771.393 -1251.208)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3110",
    "data-name": "Path 3110",
    d: "M1822.2,1332.424a1.656,1.656,0,0,1-1.519-.968l-34.664-78.015a1.581,1.581,0,0,1,.865-2.1,1.674,1.674,0,0,1,2.171.838l34.664,78.015a1.581,1.581,0,0,1-.865,2.1A1.7,1.7,0,0,1,1822.2,1332.424Z",
    transform: "translate(-1781.493 -1251.208)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3111",
    "data-name": "Path 3111",
    d: "M2127.5,1332.424a1.7,1.7,0,0,1-.652-.131,1.582,1.582,0,0,1-.865-2.1l34.665-78.015a1.674,1.674,0,0,1,2.171-.838,1.582,1.582,0,0,1,.865,2.1l-34.664,78.015A1.656,1.656,0,0,1,2127.5,1332.424Z",
    transform: "translate(-2018.547 -1251.208)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3112",
    "data-name": "Path 3112",
    d: "M2176.65,1332.424a1.656,1.656,0,0,1-1.519-.968l-34.664-78.015a1.581,1.581,0,0,1,.865-2.1,1.674,1.674,0,0,1,2.172.838l34.664,78.015a1.582,1.582,0,0,1-.865,2.1A1.7,1.7,0,0,1,2176.65,1332.424Z",
    transform: "translate(-2028.646 -1251.208)",
    fill: "#7d97f4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    "data-name": "Path 3113",
    d: "M1902.84,1241.664a1.9,1.9,0,0,0-.328-1.443,1.5,1.5,0,0,0-1.2-.635h-157.7a1.757,1.757,0,0,0-1.512.927,2.219,2.219,0,0,0-.117,1.925l1.709,4.141a2.393,2.393,0,0,0,2.172,1.555h154.363a1.878,1.878,0,0,0,1.779-1.643Z",
    transform: "translate(-1741.817 -1239.586)",
    fill: "#7d97f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1964",
    "data-name": "Group 1964",
    transform: "translate(1266.165 407.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1756",
    "data-name": "Group 1756",
    transform: "translate(113.228 20.147)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    cx: 29.12,
    cy: 29.12,
    r: 29.12,
    transform: "translate(0 57.519) rotate(-80.97)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_175",
    "data-name": "Ellipse 175",
    cx: 28.152,
    cy: 28.152,
    r: 28.152,
    transform: "translate(1.108 56.714) rotate(-80.97)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M1625.728,368.544a.594.594,0,0,1-.53-.862,26.47,26.47,0,0,1,23.744-14.619,26.76,26.76,0,0,1,4.795.432.594.594,0,1,1-.213,1.168,25.644,25.644,0,0,0-4.582-.412,25.288,25.288,0,0,0-22.683,13.966A.594.594,0,0,1,1625.728,368.544Z",
    transform: "translate(-1615.612 -346.315)",
    fill: "#fff",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_176",
    "data-name": "Ellipse 176",
    cx: 23.827,
    cy: 23.827,
    r: 23.827,
    transform: "matrix(0.998, -0.057, 0.057, 0.998, 8.807, 11.502)",
    fill: "#fff",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1755",
    "data-name": "Group 1755",
    transform: "translate(23.449 17.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3115",
    "data-name": "Path 3115",
    d: "M1679.3,421.769v-2.592a21.139,21.139,0,0,1-7.274-1.577,1.5,1.5,0,0,1-.829-1.771l.658-2.414a1.512,1.512,0,0,1,2.052-.989,17.55,17.55,0,0,0,6.716,1.414c2.6,0,4.544-.882,4.544-2.691,0-1.633-1.5-2.6-5.118-3.573-5.161-1.412-8.867-3.662-8.867-8.206,0-4.1,3-7.235,8.205-8.073V388.7a1.511,1.511,0,0,1,1.51-1.51h1.523a1.51,1.51,0,0,1,1.51,1.51v2.328a19.265,19.265,0,0,1,5.765,1.035,1.5,1.5,0,0,1,.939,1.814l-.606,2.233a1.506,1.506,0,0,1-1.988,1.017,15.733,15.733,0,0,0-5.655-1.026c-3.088,0-3.971,1.279-3.971,2.426,0,1.412,1.853,2.382,5.867,3.618,5.735,1.72,8.117,4.1,8.117,8.382,0,3.927-2.911,7.456-8.558,8.338v2.9a1.51,1.51,0,0,1-1.51,1.51h-1.523A1.51,1.51,0,0,1,1679.3,421.769Z",
    transform: "translate(-1671.14 -387.192)",
    fill: "url(#linear-gradient-51)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1758",
    "data-name": "Group 1758",
    transform: "translate(81.777 19.723)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 29.12,
    cy: 29.12,
    r: 29.12,
    transform: "translate(0 57.347) rotate(-79.952)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_178",
    "data-name": "Ellipse 178",
    cx: 28.152,
    cy: 28.152,
    r: 28.152,
    transform: "matrix(0.176, -0.984, 0.984, 0.176, 1.077, 56.498)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3116",
    "data-name": "Path 3116",
    d: "M1523.235,368.544a.594.594,0,0,1-.53-.862,26.469,26.469,0,0,1,23.744-14.619,26.756,26.756,0,0,1,4.795.432.594.594,0,1,1-.213,1.168,25.642,25.642,0,0,0-4.582-.412,25.289,25.289,0,0,0-22.684,13.966A.594.594,0,0,1,1523.235,368.544Z",
    transform: "translate(-1512.695 -345.89)",
    fill: "#fff",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_179",
    "data-name": "Ellipse 179",
    cx: 23.827,
    cy: 23.827,
    r: 23.827,
    transform: "translate(8.656 12.587) rotate(-4.731)",
    fill: "#fff",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1757",
    "data-name": "Group 1757",
    transform: "translate(23.873 17.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3117",
    "data-name": "Path 3117",
    d: "M1576.8,421.769v-2.592a21.137,21.137,0,0,1-7.274-1.577,1.5,1.5,0,0,1-.829-1.771l.659-2.414a1.512,1.512,0,0,1,2.052-.989,17.55,17.55,0,0,0,6.716,1.414c2.6,0,4.544-.882,4.544-2.691,0-1.633-1.5-2.6-5.117-3.573-5.162-1.412-8.868-3.662-8.868-8.206,0-4.1,3-7.235,8.206-8.073V388.7a1.51,1.51,0,0,1,1.51-1.51h1.523a1.51,1.51,0,0,1,1.51,1.51v2.328a19.268,19.268,0,0,1,5.765,1.035,1.5,1.5,0,0,1,.939,1.814l-.606,2.233a1.506,1.506,0,0,1-1.988,1.017,15.731,15.731,0,0,0-5.655-1.026c-3.088,0-3.97,1.279-3.97,2.426,0,1.412,1.853,2.382,5.867,3.618,5.735,1.72,8.117,4.1,8.117,8.382,0,3.927-2.912,7.456-8.558,8.338v2.9a1.51,1.51,0,0,1-1.51,1.51h-1.524A1.51,1.51,0,0,1,1576.8,421.769Z",
    transform: "translate(-1568.646 -387.192)",
    fill: "url(#linear-gradient-51)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1760",
    "data-name": "Group 1760",
    transform: "translate(51.776 20.749)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_180",
    "data-name": "Ellipse 180",
    cx: 29.12,
    cy: 29.12,
    r: 29.12,
    transform: "translate(0 57.725) rotate(-82.372)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_181",
    "data-name": "Ellipse 181",
    cx: 28.152,
    cy: 28.152,
    r: 28.152,
    transform: "matrix(0.16, -0.987, 0.987, 0.16, 0.43, 56.007)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3118",
    "data-name": "Path 3118",
    d: "M1420.741,368.544a.594.594,0,0,1-.53-.862,26.47,26.47,0,0,1,23.744-14.619,26.757,26.757,0,0,1,4.795.432.594.594,0,1,1-.213,1.168,25.648,25.648,0,0,0-4.582-.412,25.287,25.287,0,0,0-22.683,13.966A.594.594,0,0,1,1420.741,368.544Z",
    transform: "translate(-1411.228 -346.917)",
    fill: "#fff",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 23.827,
    cy: 23.827,
    r: 23.827,
    transform: "translate(6.781 12.604) rotate(-7.018)",
    fill: "#fff",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1759",
    "data-name": "Group 1759",
    transform: "translate(22.847 16.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    "data-name": "Path 3119",
    d: "M1474.309,421.769v-2.592a21.138,21.138,0,0,1-7.274-1.577,1.5,1.5,0,0,1-.829-1.771l.659-2.414a1.512,1.512,0,0,1,2.052-.989,17.551,17.551,0,0,0,6.716,1.414c2.6,0,4.544-.882,4.544-2.691,0-1.633-1.5-2.6-5.117-3.573-5.162-1.412-8.868-3.662-8.868-8.206,0-4.1,3-7.235,8.205-8.073V388.7a1.511,1.511,0,0,1,1.511-1.51h1.523a1.51,1.51,0,0,1,1.511,1.51v2.328a19.265,19.265,0,0,1,5.765,1.035,1.5,1.5,0,0,1,.939,1.814l-.605,2.233a1.506,1.506,0,0,1-1.989,1.017,15.731,15.731,0,0,0-5.655-1.026c-3.088,0-3.97,1.279-3.97,2.426,0,1.412,1.853,2.382,5.867,3.618,5.735,1.72,8.118,4.1,8.118,8.382,0,3.927-2.912,7.456-8.558,8.338v2.9a1.511,1.511,0,0,1-1.511,1.51h-1.523A1.51,1.51,0,0,1,1474.309,421.769Z",
    transform: "translate(-1466.153 -387.192)",
    fill: "url(#linear-gradient-51)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1762",
    "data-name": "Group 1762",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_183",
    "data-name": "Ellipse 183",
    cx: 38.187,
    cy: 38.187,
    r: 38.187,
    transform: "translate(0.901 76.4) rotate(-81.323)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_184",
    "data-name": "Ellipse 184",
    cx: 36.917,
    cy: 36.917,
    r: 36.917,
    transform: "translate(0 71.858) rotate(-76.717)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3120",
    "data-name": "Path 3120",
    d: "M1264.424,316.317a.594.594,0,0,1-.53-.862,34.527,34.527,0,0,1,30.971-19.07,34.98,34.98,0,0,1,6.255.563.594.594,0,1,1-.213,1.169,33.831,33.831,0,0,0-6.041-.543,33.345,33.345,0,0,0-29.911,18.417A.594.594,0,0,1,1264.424,316.317Z",
    transform: "translate(-1250.455 -286.647)",
    fill: "#fff",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_185",
    "data-name": "Ellipse 185",
    cx: 31.246,
    cy: 31.246,
    r: 31.246,
    transform: "translate(1.028 45.215) rotate(-45)",
    fill: "#fff",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1761",
    "data-name": "Group 1761",
    transform: "translate(31.453 23.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3121",
    "data-name": "Path 3121",
    d: "M1334.244,385.872v-3.4a27.726,27.726,0,0,1-9.538-2.068,1.967,1.967,0,0,1-1.087-2.323l.864-3.166a1.982,1.982,0,0,1,2.69-1.3,23.015,23.015,0,0,0,8.807,1.854c3.413,0,5.958-1.157,5.958-3.529,0-2.141-1.967-3.413-6.711-4.686-6.768-1.851-11.628-4.8-11.628-10.761,0-5.38,3.934-9.488,10.76-10.586v-3.4a1.981,1.981,0,0,1,1.981-1.981h2a1.981,1.981,0,0,1,1.981,1.981v3.052a25.274,25.274,0,0,1,7.56,1.358,1.97,1.97,0,0,1,1.231,2.379l-.794,2.928a1.975,1.975,0,0,1-2.607,1.334,20.624,20.624,0,0,0-7.415-1.346c-4.05,0-5.206,1.677-5.206,3.182,0,1.851,2.43,3.124,7.694,4.744,7.521,2.256,10.645,5.38,10.645,10.991,0,5.149-3.818,9.777-11.223,10.934v3.8a1.981,1.981,0,0,1-1.981,1.981h-2A1.981,1.981,0,0,1,1334.244,385.872Z",
    transform: "translate(-1323.548 -340.53)",
    fill: "url(#linear-gradient-60)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1968",
    "data-name": "Group 1968",
    transform: "translate(1466.042 363.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1765",
    "data-name": "Group 1765",
    transform: "translate(0 0)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3122",
    "data-name": "Path 3122",
    d: "M1833,519.426a11.233,11.233,0,1,1,11.786-10.652A11.246,11.246,0,0,1,1833,519.426Zm.909-17.985a6.775,6.775,0,1,0,6.424,7.108A6.782,6.782,0,0,0,1833.911,501.441Z",
    transform: "translate(-1822.336 -443.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1764",
    "data-name": "Group 1764",
    transform: "translate(3.399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3123",
    "data-name": "Path 3123",
    d: "M1851.982,439.549a23.991,23.991,0,0,1,22.724,25.143,23.228,23.228,0,0,1-.25,2.414,1.635,1.635,0,0,0,1.762,1.9l3.509-.344a1.643,1.643,0,0,0,1.464-1.441c.09-.724.157-1.455.194-2.2a30.686,30.686,0,0,0-29.065-32.159,30.207,30.207,0,0,0-3.787.048,1.64,1.64,0,0,0-1.513,1.824l.405,3.415a1.622,1.622,0,0,0,1.731,1.428A22.881,22.881,0,0,1,1851.982,439.549Z",
    transform: "translate(-1842.938 -398.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3124",
    "data-name": "Path 3124",
    d: "M1848.165,382.5a41.286,41.286,0,0,1,39.106,43.269v.02a1.619,1.619,0,0,0,1.767,1.709l3.443-.338,1.493-1.561a47.864,47.864,0,0,0-52.236-49.633,1.621,1.621,0,0,0-1.443,1.812l.4,3.406a1.62,1.62,0,0,0,1.741,1.431A40.819,40.819,0,0,1,1848.165,382.5Z",
    transform: "translate(-1838.249 -358.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3125",
    "data-name": "Path 3125",
    d: "M1844.353,325.457A58.58,58.58,0,0,1,1899.9,384.35a1.636,1.636,0,0,0,1.786,1.659l3.416-.335a1.635,1.635,0,0,0,1.479-1.61,65.1,65.1,0,0,0-71.562-65.044,1.63,1.63,0,0,0-1.444,1.819l.4,3.4a1.63,1.63,0,0,0,1.791,1.423A58.114,58.114,0,0,1,1844.353,325.457Z",
    transform: "translate(-1833.565 -318.697)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1965",
    "data-name": "Group 1965",
    transform: "translate(1069.024 384.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3126",
    "data-name": "Path 3126",
    d: "M510.963,451.581l1.459-1.036a.316.316,0,1,1,.366.516l0,0-.006,0-1.472,1,0,0a.3.3,0,0,1-.339-.488Z",
    transform: "translate(-510.838 -431.538)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3127",
    "data-name": "Path 3127",
    d: "M527.146,440.7l1.517-.951a.38.38,0,1,1,.4.644l-.005,0-.007,0-1.526.911-.005,0a.361.361,0,0,1-.377-.616Z",
    transform: "translate(-522.091 -424.012)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3128",
    "data-name": "Path 3128",
    d: "M543.94,430.781l1.57-.862a.443.443,0,0,1,.426.776l-.006,0-.009,0-1.574.824-.007,0a.425.425,0,0,1-.4-.749Z",
    transform: "translate(-533.766 -417.16)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3129",
    "data-name": "Path 3129",
    d: "M561.3,421.889l1.619-.77a.49.49,0,0,1,.421.885l0,0-.01,0-1.616.737-.007,0a.476.476,0,0,1-.4-.862Z",
    transform: "translate(-545.835 -411.028)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3130",
    "data-name": "Path 3130",
    d: "M579.15,413.99l1.66-.68a.538.538,0,1,1,.407,1l-.005,0-.011,0-1.654.647-.008,0a.523.523,0,0,1-.389-.971Z",
    transform: "translate(-558.244 -405.589)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3131",
    "data-name": "Path 3131",
    d: "M597.419,407.1l1.7-.587a.585.585,0,1,1,.383,1.106l-.006,0-.012,0-1.687.554-.009,0a.571.571,0,0,1-.365-1.082Z",
    transform: "translate(-570.941 -400.853)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3132",
    "data-name": "Path 3132",
    d: "M616.047,401.229l1.727-.494a.633.633,0,1,1,.348,1.217l-.007,0-.013,0-1.714.461-.01,0a.618.618,0,0,1-.331-1.192Z",
    transform: "translate(-583.885 -396.831)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3133",
    "data-name": "Path 3133",
    d: "M634.977,396.4l1.752-.4a.681.681,0,1,1,.3,1.327h-.007l-.015,0-1.736.366-.011,0a.666.666,0,0,1-.285-1.3Z",
    transform: "translate(-597.036 -393.532)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3134",
    "data-name": "Path 3134",
    d: "M654.152,392.615l1.771-.3a.728.728,0,1,1,.245,1.435h-.008l-.015,0-1.752.271-.012,0a.714.714,0,0,1-.229-1.409Z",
    transform: "translate(-610.354 -390.968)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3135",
    "data-name": "Path 3135",
    d: "M673.52,389.933l1.786-.2a.765.765,0,0,1,.169,1.52h-.007l-.013,0-1.763.179h-.012a.756.756,0,0,1-.16-1.5Z",
    transform: "translate(-623.803 -389.174)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3136",
    "data-name": "Path 3136",
    d: "M693.061,388.366l1.794-.1a.794.794,0,0,1,.088,1.585h-.021l-1.769.08h-.013a.785.785,0,0,1-.079-1.568Z",
    transform: "translate(-637.381 -388.153)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3137",
    "data-name": "Path 3137",
    d: "M712.661,387.895l1.8,0a.823.823,0,1,1,0,1.646h-.022l-1.769-.02h-.014a.814.814,0,0,1,.01-1.628Z",
    transform: "translate(-650.997 -387.895)",
    fill: "url(#linear-gradient-72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3138",
    "data-name": "Path 3138",
    d: "M732.259,388.313l1.793.105a.852.852,0,1,1-.1,1.7h-.023l-1.763-.12h-.015a.843.843,0,0,1,.107-1.683Z",
    transform: "translate(-664.608 -388.185)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3139",
    "data-name": "Path 3139",
    d: "M751.791,389.859l1.785.209a.881.881,0,0,1-.205,1.75h-.009l-.015,0-1.752-.223-.015,0a.872.872,0,0,1,.212-1.732Z",
    transform: "translate(-678.17 -389.26)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3140",
    "data-name": "Path 3140",
    d: "M771.2,392.553l1.77.315a.91.91,0,0,1-.319,1.792l-.009,0-.016,0-1.735-.326-.016,0a.9.9,0,0,1,.325-1.773Z",
    transform: "translate(-691.646 -391.133)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3141",
    "data-name": "Path 3141",
    d: "M790.41,396.4l1.749.422a.939.939,0,1,1-.44,1.826l-.009,0-.017,0-1.712-.43-.016,0a.93.93,0,0,1,.445-1.807Z",
    transform: "translate(-704.977 -393.81)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3142",
    "data-name": "Path 3142",
    d: "M809.359,401.428l1.723.531a.968.968,0,1,1-.57,1.851l-.009,0-.017-.005-1.683-.536-.017-.005a.959.959,0,0,1,.574-1.831Z",
    transform: "translate(-718.124 -397.302)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3143",
    "data-name": "Path 3143",
    d: "M827.961,407.627l1.686.636a1,1,0,1,1-.7,1.866l-.009,0-.017-.007-1.646-.639-.017-.007a.988.988,0,0,1,.707-1.846Z",
    transform: "translate(-731.029 -401.61)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3144",
    "data-name": "Path 3144",
    d: "M846.148,414.968l1.644.738a1.027,1.027,0,0,1-.84,1.873l-.009,0-.017-.008-1.6-.738-.017-.008a1.018,1.018,0,0,1,.842-1.853Z",
    transform: "translate(-743.643 -406.711)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3145",
    "data-name": "Path 3145",
    d: "M863.847,423.4l1.6.835a1.056,1.056,0,0,1-.978,1.871l-.009,0-.017-.009-1.556-.833-.017-.009a1.047,1.047,0,0,1,.979-1.851Z",
    transform: "translate(-755.916 -412.567)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3146",
    "data-name": "Path 3146",
    d: "M881.024,432.9l1.543.934a1.066,1.066,0,1,1-1.1,1.825l0,0-.016-.009-1.508-.919-.016-.01a1.063,1.063,0,0,1,1.1-1.818Z",
    transform: "translate(-767.836 -419.171)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M897.631,443.44l1.486,1.023a1.076,1.076,0,0,1-1.22,1.773l0,0-.015-.011-1.452-1.006-.016-.011a1.073,1.073,0,0,1,1.22-1.766Z",
    transform: "translate(-779.368 -426.492)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    "data-name": "Path 3148",
    d: "M913.592,454.93l1.422,1.106a1.086,1.086,0,0,1-1.333,1.714l0,0-.015-.012-1.389-1.087-.015-.012a1.083,1.083,0,0,1,1.332-1.707Z",
    transform: "translate(-790.452 -434.477)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M928.85,467.326l1.356,1.187a1.1,1.1,0,0,1-1.443,1.648l0,0-.014-.012-1.323-1.166-.015-.013a1.092,1.092,0,0,1,1.442-1.641Z",
    transform: "translate(-801.045 -443.091)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    "data-name": "Path 3150",
    d: "M943.359,480.59l1.286,1.266a1.1,1.1,0,0,1-1.55,1.575l0,0-.014-.014-1.254-1.243-.014-.014a1.1,1.1,0,0,1,1.549-1.568Z",
    transform: "translate(-811.119 -452.307)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3151",
    "data-name": "Path 3151",
    d: "M957.074,494.688l1.209,1.339a1.114,1.114,0,1,1-1.654,1.494l0,0-.013-.015-1.179-1.313-.013-.015a1.112,1.112,0,0,1,1.653-1.487Z",
    transform: "translate(-820.639 -462.103)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3152",
    "data-name": "Path 3152",
    d: "M969.932,509.569l1.127,1.408a1.124,1.124,0,1,1-1.755,1.405l0,0-.012-.016-1.1-1.38-.013-.016a1.121,1.121,0,0,1,1.753-1.4Z",
    transform: "translate(-829.562 -472.442)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3153",
    "data-name": "Path 3153",
    d: "M981.878,525.192l1.04,1.473a1.134,1.134,0,0,1-1.852,1.308l0,0-.012-.017-1.011-1.442-.012-.017a1.131,1.131,0,0,1,1.849-1.3Z",
    transform: "translate(-837.852 -483.295)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3154",
    "data-name": "Path 3154",
    d: "M992.85,541.505l.948,1.534a1.143,1.143,0,1,1-1.945,1.2l0,0-.011-.018-.921-1.5-.011-.018a1.141,1.141,0,0,1,1.942-1.2Z",
    transform: "translate(-845.463 -494.626)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3155",
    "data-name": "Path 3155",
    d: "M1002.8,558.467l.85,1.59a1.153,1.153,0,0,1-2.033,1.088l0,0-.01-.019-.825-1.554-.01-.019a1.15,1.15,0,0,1,2.03-1.082Z",
    transform: "translate(-852.361 -506.407)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3156",
    "data-name": "Path 3156",
    d: "M1011.654,576.023l.747,1.641a1.163,1.163,0,1,1-2.116.964l0,0-.009-.021-.724-1.6-.009-.021a1.16,1.16,0,0,1,2.112-.958Z",
    transform: "translate(-858.502 -518.599)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3157",
    "data-name": "Path 3157",
    d: "M1019.362,594.108l.64,1.688a1.172,1.172,0,0,1-2.193.83v0l-.008-.022-.618-1.647-.008-.022a1.169,1.169,0,0,1,2.188-.825Z",
    transform: "translate(-863.843 -531.156)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3158",
    "data-name": "Path 3158",
    d: "M1025.879,612.67l.531,1.724a1.182,1.182,0,0,1-2.259.7v0l-.006-.021-.513-1.685-.006-.021a1.179,1.179,0,0,1,2.254-.69Z",
    transform: "translate(-868.357 -544.045)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3159",
    "data-name": "Path 3159",
    d: "M1031.242,631.594l.428,1.751a1.191,1.191,0,1,1-2.315.566v0l0-.02-.414-1.713,0-.02a1.189,1.189,0,0,1,2.31-.561Z",
    transform: "translate(-872.071 -557.189)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3160",
    "data-name": "Path 3160",
    d: "M1035.5,650.787l.326,1.772a1.2,1.2,0,1,1-2.353.433l0-.016-.323-1.734,0-.019a1.2,1.2,0,0,1,2.356-.439Z",
    transform: "translate(-875.017 -570.52)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3161",
    "data-name": "Path 3161",
    d: "M1038.74,670.222l.235,1.785a1.191,1.191,0,0,1-2.362.311l0-.015-.233-1.749,0-.018a1.193,1.193,0,1,1,2.364-.315Z",
    transform: "translate(-877.277 -584.033)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3162",
    "data-name": "Path 3162",
    d: "M1041,689.79l.15,1.792a1.185,1.185,0,1,1-2.363.2v-.014l-.151-1.76v-.016a1.187,1.187,0,0,1,2.366-.2Z",
    transform: "translate(-878.859 -597.641)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3163",
    "data-name": "Path 3163",
    d: "M1042.371,709.435l.073,1.8a1.18,1.18,0,0,1-2.358.1v-.013l-.075-1.766v-.015a1.182,1.182,0,0,1,2.362-.1Z",
    transform: "translate(-879.817 -611.307)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3164",
    "data-name": "Path 3164",
    d: "M1042.919,729.115l0,1.8a1.175,1.175,0,1,1-2.349,0V730.9l-.006-1.77v-.013a1.176,1.176,0,0,1,2.353-.007Z",
    transform: "translate(-880.206 -625.002)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3165",
    "data-name": "Path 3165",
    d: "M1042.594,748.8l-.06,1.793a1.169,1.169,0,1,1-2.337-.079V750.5l.056-1.77v-.012a1.171,1.171,0,0,1,2.341.074Z",
    transform: "translate(-879.948 -638.701)",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3166",
    "data-name": "Path 3166",
    d: "M1041.609,768.456l-.116,1.789a1.164,1.164,0,1,1-2.323-.151v-.008l.112-1.769v-.01a1.165,1.165,0,1,1,2.326.147Z",
    transform: "translate(-879.231 -652.387)",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3167",
    "data-name": "Path 3167",
    d: "M1040.051,788.077l-.166,1.784a1.158,1.158,0,1,1-2.306-.214v-.007l.161-1.766v-.009a1.16,1.16,0,0,1,2.31.21Z",
    transform: "translate(-878.12 -666.05)",
    fill: "url(#linear-gradient-102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3168",
    "data-name": "Path 3168",
    d: "M1037.991,807.648l-.208,1.778a1.153,1.153,0,1,1-2.29-.268v-.005l.2-1.763v-.008a1.154,1.154,0,1,1,2.293.265Z",
    transform: "translate(-876.663 -679.681)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3169",
    "data-name": "Path 3169",
    d: "M1035.495,827.164l-.245,1.772a1.147,1.147,0,0,1-2.273-.315v0l.24-1.759v-.007a1.149,1.149,0,0,1,2.276.311Z",
    transform: "translate(-874.907 -693.277)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3170",
    "data-name": "Path 3170",
    d: "M1032.627,846.624l-.277,1.769a1.142,1.142,0,0,1-2.256-.354v0l.272-1.758v-.005a1.143,1.143,0,1,1,2.26.349Z",
    transform: "translate(-872.894 -706.837)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3171",
    "data-name": "Path 3171",
    d: "M1029.453,866.04l-.3,1.762a1.136,1.136,0,1,1-2.24-.383v0l.3-1.755v0a1.138,1.138,0,1,1,2.244.38Z",
    transform: "translate(-870.674 -720.368)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3172",
    "data-name": "Path 3172",
    d: "M1026.061,885.4l-.318,1.759a1.131,1.131,0,1,1-2.226-.4l.314-1.755a1.132,1.132,0,1,1,2.23.393Z",
    transform: "translate(-868.306 -733.868)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3173",
    "data-name": "Path 3173",
    d: "M1022.529,904.744l-.327,1.753a1.125,1.125,0,0,1-2.213-.412l.323-1.752a1.127,1.127,0,0,1,2.217.407Z",
    transform: "translate(-865.845 -747.353)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3174",
    "data-name": "Path 3174",
    d: "M1018.931,924.055l-.33,1.752a1.12,1.12,0,0,1-2.2-.412l.327-1.752a1.121,1.121,0,1,1,2.2.411Z",
    transform: "translate(-863.342 -760.821)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3175",
    "data-name": "Path 3175",
    d: "M1015.338,943.357l-.327,1.751a1.114,1.114,0,0,1-2.192-.405l.324-1.754a1.116,1.116,0,0,1,2.2.4Z",
    transform: "translate(-860.846 -774.285)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3176",
    "data-name": "Path 3176",
    d: "M1011.822,962.666l-.317,1.752a1.109,1.109,0,1,1-2.183-.39l.314-1.757a1.111,1.111,0,1,1,2.187.391Z",
    transform: "translate(-858.408 -787.757)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3177",
    "data-name": "Path 3177",
    d: "M1008.451,982l-.3,1.753v0a1.1,1.1,0,0,1-2.176-.37l.3-1.761a1.105,1.105,0,1,1,2.179.369V982Z",
    transform: "translate(-856.076 -801.245)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3178",
    "data-name": "Path 3178",
    d: "M1005.3,1001.355l-.277,1.756v.005a1.1,1.1,0,0,1-2.17-.34l.275-1.766a1.1,1.1,0,1,1,2.173.338v.007Z",
    transform: "translate(-853.903 -814.758)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3179",
    "data-name": "Path 3179",
    d: "M1002.451,1020.756l-.247,1.761v.006a1.093,1.093,0,0,1-2.164-.3l.246-1.773a1.094,1.094,0,1,1,2.168.3v.008Z",
    transform: "translate(-851.94 -828.302)",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3180",
    "data-name": "Path 3180",
    d: "M999.966,1040.218l-.211,1.763v.007a1.087,1.087,0,0,1-2.159-.256l.209-1.778a1.089,1.089,0,0,1,2.163.254v.009Z",
    transform: "translate(-850.238 -841.892)",
    fill: "url(#linear-gradient-115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3181",
    "data-name": "Path 3181",
    d: "M997.929,1059.711l-.167,1.766v.008a1.082,1.082,0,0,1-2.154-.2l.166-1.782a1.083,1.083,0,0,1,2.157.2v.011Z",
    transform: "translate(-848.854 -855.506)",
    fill: "url(#linear-gradient-116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3182",
    "data-name": "Path 3182",
    d: "M996.413,1079.238l-.117,1.767v.01a1.076,1.076,0,0,1-2.147-.14l.115-1.787a1.078,1.078,0,1,1,2.151.138v.012Z",
    transform: "translate(-847.839 -869.146)",
    fill: "url(#linear-gradient-117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3183",
    "data-name": "Path 3183",
    d: "M995.493,1098.809l-.06,1.769v.011a1.071,1.071,0,0,1-2.14-.071l.057-1.791a1.072,1.072,0,0,1,2.144.069v.013Z",
    transform: "translate(-847.243 -882.819)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3184",
    "data-name": "Path 3184",
    d: "M995.226,1118.4l0,1.771v.013a1.065,1.065,0,0,1-2.13.006l-.007-1.8a1.067,1.067,0,0,1,2.134-.008v.014Z",
    transform: "translate(-847.104 -896.508)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3185",
    "data-name": "Path 3185",
    d: "M995.592,1137.987l.084,1.765v.015a1.06,1.06,0,0,1-2.117.1l-.088-1.8a1.061,1.061,0,0,1,2.12-.1v.017Z",
    transform: "translate(-847.367 -910.203)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3186",
    "data-name": "Path 3186",
    d: "M996.879,1157.533l.168,1.758,0,.016a1.048,1.048,0,0,1-2.086.205l-.181-1.79a1.053,1.053,0,1,1,2.095-.212v.006Z",
    transform: "translate(-848.278 -923.872)",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3187",
    "data-name": "Path 3187",
    d: "M999.185,1177.007l.265,1.745,0,.018a1.031,1.031,0,0,1-2.039.315l-.28-1.779a1.036,1.036,0,1,1,2.047-.322v.006Z",
    transform: "translate(-849.913 -937.499)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3188",
    "data-name": "Path 3188",
    d: "M1002.6,1196.314l.371,1.724,0,.019a1.015,1.015,0,0,1-1.983.433l-.389-1.76a1.02,1.02,0,1,1,1.991-.44v.005Z",
    transform: "translate(-852.322 -951.013)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3189",
    "data-name": "Path 3189",
    d: "M1007.234,1215.359l.488,1.692.006.021a1,1,0,0,1-1.917.558l-.51-1.731a1,1,0,1,1,1.924-.567l0,.005Z",
    transform: "translate(-855.589 -964.348)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3190",
    "data-name": "Path 3190",
    d: "M1013.217,1234.019l.616,1.647.009.023a.982.982,0,0,1-1.837.693l-.642-1.689a.987.987,0,1,1,1.844-.7l0,.005Z",
    transform: "translate(-859.798 -977.416)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3191",
    "data-name": "Path 3191",
    d: "M1020.671,1252.134l.755,1.585.011.024a.965.965,0,0,1-1.74.834l-.786-1.628a.97.97,0,1,1,1.747-.843l0,0Z",
    transform: "translate(-865.039 -990.108)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3192",
    "data-name": "Path 3192",
    d: "M1029.706,1269.5l.9,1.5.015.025a.948.948,0,0,1-1.624.979l-.939-1.548a.954.954,0,0,1,1.63-.989l0,0Z",
    transform: "translate(-871.388 -1002.282)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3193",
    "data-name": "Path 3193",
    d: "M1040.4,1285.9l1.052,1.4.018.024a.932.932,0,0,1-1.488,1.123l-1.1-1.444a.937.937,0,0,1,1.492-1.133l0,0Z",
    transform: "translate(-878.902 -1013.778)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3194",
    "data-name": "Path 3194",
    d: "M1052.782,1301.079c.4.429.793.858,1.2,1.276a.916.916,0,0,1-1.308,1.282c-.425-.432-.839-.874-1.252-1.316a.92.92,0,0,1,1.345-1.257l0,0Z",
    transform: "translate(-887.604 -1024.425)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3195",
    "data-name": "Path 3195",
    d: "M1066.788,1314.724l1.343,1.123.025.021a.9.9,0,0,1-1.149,1.382l-1.4-1.156a.9.9,0,0,1,1.152-1.393l0,0Z",
    transform: "translate(-897.438 -1033.992)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3196",
    "data-name": "Path 3196",
    d: "M1082.32,1326.628l1.465.961.025.016a.882.882,0,0,1-.963,1.478l-1.521-.985a.887.887,0,0,1,.965-1.49l0,0Z",
    transform: "translate(-908.345 -1042.341)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3197",
    "data-name": "Path 3197",
    d: "M1099.109,1336.69l1.564.793.025.013a.866.866,0,0,1-.779,1.547l-1.619-.81a.871.871,0,0,1,.779-1.557l0,0Z",
    transform: "translate(-920.128 -1049.395)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3198",
    "data-name": "Path 3198",
    d: "M1116.9,1344.875l1.641.625.024.009a.849.849,0,0,1-.6,1.589l-1.693-.634a.854.854,0,1,1,.6-1.6l0,0Z",
    transform: "translate(-932.605 -1055.131)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3199",
    "data-name": "Path 3199",
    d: "M1135.438,1351.185l1.7.459.024.006a.833.833,0,0,1-.43,1.609l-1.747-.461a.838.838,0,0,1,.428-1.62h0Z",
    transform: "translate(-945.605 -1059.552)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3200",
    "data-name": "Path 3200",
    d: "M1154.512,1355.645l1.735.295.023,0a.816.816,0,0,1-.268,1.61l-1.782-.292a.821.821,0,1,1,.266-1.62h0Z",
    transform: "translate(-958.974 -1062.676)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3201",
    "data-name": "Path 3201",
    d: "M1173.926,1358.29l1.756.133.022,0a.8.8,0,0,1-.116,1.595l-1.8-.127a.8.8,0,0,1,.113-1.6h0Z",
    transform: "translate(-972.576 -1064.528)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3202",
    "data-name": "Path 3202",
    d: "M1193.5,1359.091l1.762-.026h.021a.783.783,0,0,1,.027,1.566l-1.8.036a.788.788,0,0,1-.032-1.576h.025Z",
    transform: "translate(-986.287 -1065.071)",
    fill: "url(#linear-gradient-72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    "data-name": "Path 3203",
    d: "M1213.071,1357.823l1.752-.183.021,0a.766.766,0,0,1,.164,1.524l-1.792.2a.771.771,0,0,1-.169-1.534h0Z",
    transform: "translate(-999.994 -1064.073)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3204",
    "data-name": "Path 3204",
    d: "M1232.48,1354.813l1.729-.34.02,0a.75.75,0,0,1,.293,1.471l-1.767.358a.755.755,0,1,1-.3-1.48h0Z",
    transform: "translate(-1013.585 -1061.857)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3205",
    "data-name": "Path 3205",
    d: "M1251.584,1350.1l1.692-.493.019-.006a.723.723,0,0,1,.411,1.385l-1.726.521a.731.731,0,0,1-.423-1.4l.007,0Z",
    transform: "translate(-1026.963 -1058.453)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3206",
    "data-name": "Path 3206",
    d: "M1270.219,1343.656l1.64-.651.018-.007a.693.693,0,0,1,.517,1.286l-1.67.681a.7.7,0,1,1-.53-1.3l.006,0Z",
    transform: "translate(-1040.016 -1053.834)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3207",
    "data-name": "Path 3207",
    d: "M1288.191,1335.481l1.571-.8.016-.008a.663.663,0,0,1,.61,1.178l-1.593.836a.673.673,0,1,1-.625-1.191l.006,0Z",
    transform: "translate(-1052.603 -1048.01)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3208",
    "data-name": "Path 3208",
    d: "M1305.365,1325.744l1.5-.937.014-.008a.634.634,0,0,1,.678,1.072l-1.515.969a.643.643,0,0,1-.693-1.084l.005,0Z",
    transform: "translate(-1064.625 -1041.111)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3209",
    "data-name": "Path 3209",
    d: "M1321.679,1314.616l1.416-1.058.012-.009a.6.6,0,0,1,.729.965l-1.429,1.09a.614.614,0,1,1-.744-.975l0,0Z",
    transform: "translate(-1076.041 -1033.25)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3210",
    "data-name": "Path 3210",
    d: "M1337.05,1302.222l1.328-1.169.01-.009a.575.575,0,0,1,.764.86l-1.336,1.2a.584.584,0,0,1-.781-.87l0,0Z",
    transform: "translate(-1086.793 -1024.515)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3211",
    "data-name": "Path 3211",
    d: "M1351.419,1288.689l1.236-1.267.009-.009a.546.546,0,0,1,.786.758l-1.24,1.3a.555.555,0,1,1-.8-.767l0,0Z",
    transform: "translate(-1096.841 -1014.995)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3212",
    "data-name": "Path 3212",
    d: "M1364.748,1274.143l1.141-1.355.007-.008a.516.516,0,0,1,.793.662l-1.142,1.383a.525.525,0,1,1-.81-.669l0,0Z",
    transform: "translate(-1106.16 -1004.779)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3213",
    "data-name": "Path 3213",
    d: "M1377.009,1258.7l1.044-1.432.006-.008a.487.487,0,0,1,.79.57l-1.042,1.459a.5.5,0,0,1-.807-.576l0,0Z",
    transform: "translate(-1114.73 -993.948)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3214",
    "data-name": "Path 3214",
    d: "M1388.186,1242.478l.946-1.5,0-.008a.458.458,0,0,1,.777.485l-.941,1.524a.467.467,0,1,1-.794-.49l0,0Z",
    transform: "translate(-1122.541 -982.577)",
    fill: "url(#linear-gradient-116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3215",
    "data-name": "Path 3215",
    d: "M1398.27,1225.568l.847-1.559,0-.007a.428.428,0,0,1,.755.405l-.839,1.582a.437.437,0,0,1-.772-.41l0,0Z",
    transform: "translate(-1129.586 -970.739)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3216",
    "data-name": "Path 3216",
    d: "M1407.25,1208.059l.748-1.613,0-.007a.4.4,0,0,1,.725.332l-.738,1.634a.408.408,0,1,1-.743-.336v0Z",
    transform: "translate(-1135.858 -958.488)",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3217",
    "data-name": "Path 3217",
    d: "M1415.118,1190.042l.646-1.654,0-.006a.369.369,0,0,1,.689.265l-.634,1.673a.378.378,0,0,1-.708-.268l0,0Z",
    transform: "translate(-1141.354 -945.893)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3218",
    "data-name": "Path 3218",
    d: "M1421.857,1171.592l.543-1.691,0-.006a.34.34,0,0,1,.649.2l-.53,1.708a.349.349,0,1,1-.667-.206v0Z",
    transform: "translate(-1146.059 -933.002)",
    fill: "url(#linear-gradient-116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3219",
    "data-name": "Path 3219",
    d: "M1427.45,1152.777l.438-1.723v-.005a.311.311,0,0,1,.6.15l-.424,1.739a.32.32,0,0,1-.621-.151v0Z",
    transform: "translate(-1149.964 -919.862)",
    fill: "url(#linear-gradient-100)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankingFinance);
export default __webpack_public_path__ + "static/media/bankingFinance.5567535f5fe5116c1b853631b519eb9c.svg";
export { ForwardRef as ReactComponent };